// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3caO2","badges":"styles_badges__257EB"};